// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-registrierung-child {
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(245.52deg, #fff, #0a98da 82.43%);
  width: 1920px;
  height: 1440px;
  display: none;
}
.login-registrierung-item {
  position: absolute;
  bottom: -44.3px;
  left: 0;
  width: 1144px;
  height: 500px;
}
.login-registrierung-inner {
  position: absolute;
  top: 0;
  right: 0;
  width: 1057.1px;
  height: 438.7px;
}
.vector-lower-left {
  position: relative;
  top: 60%;
  right: 5%;
  width: 50%;
  height: 50%;
}
.vector-upper-right {
  position: relative;
  bottom: 11%;
  left: 5%;
  width: 50%;
  height: 50%;
}
.logo-1-icon2,
.logo-circle-blurred3 {
  position: absolute;
  height: calc(100% - 640px);
  width: calc(100% - 1120px);
  top: 332px;
  right: 204px;
  bottom: 308px;
  left: 916px;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}
.logo-1-icon2 {
  height: calc(100% - 1317.8px);
  width: calc(100% - 1770px);
  top: 659px;
  right: 529px;
  bottom: 658.8px;
  left: 1241px;
}
.logoclaim-1-icon2 {
  position: absolute;
  top: 30px;
  left: 30px;
  width: 400px;
  height: 121.1px;
  overflow: hidden;
}
.searchbg15 {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: var(--br-mini);
  background-color: var(--white-base);
  border: 1px solid var(--primary);
  box-sizing: border-box;
}
.passwort2 {
  border: 0;
  font-weight: 300;
  font-family: var(--inter-body-1-medium);
  font-size: var(--inter-body-big-size);
  background-color: transparent;
  position: absolute;
  width: calc(100% - 99px);
  top: calc(50% - 16px);
  left: 83px;
  line-height: 32px;
  color: var(--gray-50);
  text-align: left;
  display: flex;
  align-items: center;
}
.lock-icon2,
.x-icon15 {
  position: absolute;
  overflow: hidden;
}
.x-icon15 {
  top: calc(50% - 16px);
  right: 12px;
  width: 32px;
  height: 32px;
  display: none;
}
.lock-icon2 {
  top: 12px;
  left: 21px;
  width: 45px;
  height: 45px;
}
.search-56dp15,
.search-56dp16,
.user-icon3 {
  position: absolute;
  top: 213px;
  left: 0;
  width: 550px;
  height: 70px;
}
.search-56dp16,
.user-icon3 {
  top: 329px;
}
.user-icon3 {
  top: 12px;
  left: 23px;
  width: 45px;
  height: 45px;
  overflow: hidden;
}
.button-bg7,
.search-56dp17 {
  position: absolute;
  top: 97px;
  left: 0;
  width: 550px;
  height: 70px;
}
.button-bg7 {
  cursor: pointer;
  border: 0;
  padding: 0;
  background-color: var(--white-base);
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: var(--br-mini);
}
.button-bg7:hover {
  background-color: var(--color-aliceblue-100);
}
.caption9 {
  position: absolute;
  width: calc(100% - 40px);
  top: calc(50% - 18px);
  left: 20px;
  font-size: var(--inter-24-sp-h5-size);
  line-height: 36px;
  display: flex;
  font-family: var(--inter-body-1-medium);
  color: var(--gray-50);
  text-align: center;
  align-items: center;
  justify-content: center;
}
.left-icon7,
.right-icon7 {
  position: absolute;
  top: calc(50% - 23px);
  width: 0;
  height: 0;
}
.left-icon7 {
  left: 12px;
}
.right-icon7 {
  right: 442px;
}
.button-filled-m7 {
  cursor: pointer;
  border: 0;
  padding: 0;
  background-color: transparent;
  position: absolute;
  top: 491px;
  left: 0;
  width: 550px;
  height: 70px;
}
.anmeldung1 {
  position: absolute;
  top: 0;
  left: 0;
  letter-spacing: -1.25px;
  line-height: 56px;
  display: inline-block;
  width: 456px;
  height: 51px;
}
.login-input2 {
  position: absolute;
  top: 466px;
  left: 175px;
  width: 550px;
  height: 561px;
}
.button-icon-light29,
.button-icon-light30 {
  position: absolute;
  top: 30px;
  right: 30px;
  width: 48px;
  height: 48px;
}
.button-icon-light30 {
  right: 108px;
}
.icon83 {
  position: relative;
  width: 50px;
  height: 50px;
  overflow: hidden;
  flex-shrink: 0;
}
.digital-reifegrad2,
.logo19 {
  display: flex;
  align-items: center;
}
.digital-reifegrad2 {
  position: relative;
  line-height: 36px;
  width: 639px;
  height: 122px;
  flex-shrink: 0;
}
.logo19 {
  position: absolute;
  width: calc(100% - 1665px);
  top: 90px;
  right: 855px;
  left: 810px;
  height: 44px;
  flex-direction: row;
  justify-content: flex-start;
  gap: var(--gap-9xs);
  font-size: var(--inter-24-sp-h5-size);
}
.login-registrierung {
  position: relative;
  background: linear-gradient(60.52deg, #0a98da, #fff);
  width: 100%;
  height: 1440px;
  overflow: hidden;
  text-align: left;
  font-size: var(--inter-48-sp-h3-size);
  color: var(--white-base);
  font-family: var(--inter-body-1-medium);
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginRegistrierung.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,4DAA4D;EAC5D,aAAa;EACb,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,OAAO;EACP,aAAa;EACb,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,6BAA6B;EAC7B,mCAAmC;EACnC,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,uCAAuC;EACvC,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;;;EAGE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,YAAY;EACZ,YAAY;AACd;AACA;;EAEE,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,MAAM;EACN,QAAQ;EACR,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,UAAU;EACV,qCAAqC;EACrC,iBAAiB;EACjB,aAAa;EACb,uCAAuC;EACvC,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,oDAAoD;EACpD,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,wBAAwB;EACxB,uCAAuC;AACzC","sourcesContent":[".login-registrierung-child {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  background: linear-gradient(245.52deg, #fff, #0a98da 82.43%);\r\n  width: 1920px;\r\n  height: 1440px;\r\n  display: none;\r\n}\r\n.login-registrierung-item {\r\n  position: absolute;\r\n  bottom: -44.3px;\r\n  left: 0;\r\n  width: 1144px;\r\n  height: 500px;\r\n}\r\n.login-registrierung-inner {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  width: 1057.1px;\r\n  height: 438.7px;\r\n}\r\n.vector-lower-left {\r\n  position: relative;\r\n  top: 60%;\r\n  right: 5%;\r\n  width: 50%;\r\n  height: 50%;\r\n}\r\n.vector-upper-right {\r\n  position: relative;\r\n  bottom: 11%;\r\n  left: 5%;\r\n  width: 50%;\r\n  height: 50%;\r\n}\r\n.logo-1-icon2,\r\n.logo-circle-blurred3 {\r\n  position: absolute;\r\n  height: calc(100% - 640px);\r\n  width: calc(100% - 1120px);\r\n  top: 332px;\r\n  right: 204px;\r\n  bottom: 308px;\r\n  left: 916px;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  max-height: 100%;\r\n}\r\n.logo-1-icon2 {\r\n  height: calc(100% - 1317.8px);\r\n  width: calc(100% - 1770px);\r\n  top: 659px;\r\n  right: 529px;\r\n  bottom: 658.8px;\r\n  left: 1241px;\r\n}\r\n.logoclaim-1-icon2 {\r\n  position: absolute;\r\n  top: 30px;\r\n  left: 30px;\r\n  width: 400px;\r\n  height: 121.1px;\r\n  overflow: hidden;\r\n}\r\n.searchbg15 {\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  border-radius: var(--br-mini);\r\n  background-color: var(--white-base);\r\n  border: 1px solid var(--primary);\r\n  box-sizing: border-box;\r\n}\r\n.passwort2 {\r\n  border: 0;\r\n  font-weight: 300;\r\n  font-family: var(--inter-body-1-medium);\r\n  font-size: var(--inter-body-big-size);\r\n  background-color: transparent;\r\n  position: absolute;\r\n  width: calc(100% - 99px);\r\n  top: calc(50% - 16px);\r\n  left: 83px;\r\n  line-height: 32px;\r\n  color: var(--gray-50);\r\n  text-align: left;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.lock-icon2,\r\n.x-icon15 {\r\n  position: absolute;\r\n  overflow: hidden;\r\n}\r\n.x-icon15 {\r\n  top: calc(50% - 16px);\r\n  right: 12px;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: none;\r\n}\r\n.lock-icon2 {\r\n  top: 12px;\r\n  left: 21px;\r\n  width: 45px;\r\n  height: 45px;\r\n}\r\n.search-56dp15,\r\n.search-56dp16,\r\n.user-icon3 {\r\n  position: absolute;\r\n  top: 213px;\r\n  left: 0;\r\n  width: 550px;\r\n  height: 70px;\r\n}\r\n.search-56dp16,\r\n.user-icon3 {\r\n  top: 329px;\r\n}\r\n.user-icon3 {\r\n  top: 12px;\r\n  left: 23px;\r\n  width: 45px;\r\n  height: 45px;\r\n  overflow: hidden;\r\n}\r\n.button-bg7,\r\n.search-56dp17 {\r\n  position: absolute;\r\n  top: 97px;\r\n  left: 0;\r\n  width: 550px;\r\n  height: 70px;\r\n}\r\n.button-bg7 {\r\n  cursor: pointer;\r\n  border: 0;\r\n  padding: 0;\r\n  background-color: var(--white-base);\r\n  height: 100%;\r\n  width: 100%;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  border-radius: var(--br-mini);\r\n}\r\n.button-bg7:hover {\r\n  background-color: var(--color-aliceblue-100);\r\n}\r\n.caption9 {\r\n  position: absolute;\r\n  width: calc(100% - 40px);\r\n  top: calc(50% - 18px);\r\n  left: 20px;\r\n  font-size: var(--inter-24-sp-h5-size);\r\n  line-height: 36px;\r\n  display: flex;\r\n  font-family: var(--inter-body-1-medium);\r\n  color: var(--gray-50);\r\n  text-align: center;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.left-icon7,\r\n.right-icon7 {\r\n  position: absolute;\r\n  top: calc(50% - 23px);\r\n  width: 0;\r\n  height: 0;\r\n}\r\n.left-icon7 {\r\n  left: 12px;\r\n}\r\n.right-icon7 {\r\n  right: 442px;\r\n}\r\n.button-filled-m7 {\r\n  cursor: pointer;\r\n  border: 0;\r\n  padding: 0;\r\n  background-color: transparent;\r\n  position: absolute;\r\n  top: 491px;\r\n  left: 0;\r\n  width: 550px;\r\n  height: 70px;\r\n}\r\n.anmeldung1 {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  letter-spacing: -1.25px;\r\n  line-height: 56px;\r\n  display: inline-block;\r\n  width: 456px;\r\n  height: 51px;\r\n}\r\n.login-input2 {\r\n  position: absolute;\r\n  top: 466px;\r\n  left: 175px;\r\n  width: 550px;\r\n  height: 561px;\r\n}\r\n.button-icon-light29,\r\n.button-icon-light30 {\r\n  position: absolute;\r\n  top: 30px;\r\n  right: 30px;\r\n  width: 48px;\r\n  height: 48px;\r\n}\r\n.button-icon-light30 {\r\n  right: 108px;\r\n}\r\n.icon83 {\r\n  position: relative;\r\n  width: 50px;\r\n  height: 50px;\r\n  overflow: hidden;\r\n  flex-shrink: 0;\r\n}\r\n.digital-reifegrad2,\r\n.logo19 {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.digital-reifegrad2 {\r\n  position: relative;\r\n  line-height: 36px;\r\n  width: 639px;\r\n  height: 122px;\r\n  flex-shrink: 0;\r\n}\r\n.logo19 {\r\n  position: absolute;\r\n  width: calc(100% - 1665px);\r\n  top: 90px;\r\n  right: 855px;\r\n  left: 810px;\r\n  height: 44px;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  gap: var(--gap-9xs);\r\n  font-size: var(--inter-24-sp-h5-size);\r\n}\r\n.login-registrierung {\r\n  position: relative;\r\n  background: linear-gradient(60.52deg, #0a98da, #fff);\r\n  width: 100%;\r\n  height: 1440px;\r\n  overflow: hidden;\r\n  text-align: left;\r\n  font-size: var(--inter-48-sp-h3-size);\r\n  color: var(--white-base);\r\n  font-family: var(--inter-body-1-medium);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
